import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import {
  MagnifyingGlassIcon,
  HeartIcon,
  BriefcaseIcon,
  ChatBubbleLeftRightIcon,
  UserIcon
} from '@heroicons/react/24/outline';
import {
  MagnifyingGlassIcon as MagnifyingGlassIconSolid,
  HeartIcon as HeartIconSolid,
  BriefcaseIcon as BriefcaseIconSolid,
  ChatBubbleLeftRightIcon as ChatBubbleLeftRightIconSolid,
  UserIcon as UserIconSolid
} from '@heroicons/react/24/solid';

const BottomNavigation = () => {
  const location = useLocation();
  const { user } = useAuth();

  const isActive = (item) => {
    return item.activePaths.some(path => location.pathname.startsWith(path));
  };

  const navItems = [
    {
      id: 'search',
      label: 'さがす',
      path: user ? '/mobile-search' : '/register/type',
      icon: MagnifyingGlassIcon,
      activeIcon: MagnifyingGlassIconSolid,
      activePaths: ['/mobile-search', '/jobs', '/area-search']
    },
    {
      id: 'favorites',
      label: 'おきにいり',
      path: user ? '/favorites' : '/register/type',
      icon: HeartIcon,
      activeIcon: HeartIconSolid,
      activePaths: ['/favorites']
    },
    {
      id: 'work',
      label: 'はたらく',
      path: user ? '/work' : '/register/type',
      icon: BriefcaseIcon,
      activeIcon: BriefcaseIconSolid,
      activePaths: ['/work', '/work/upcoming', '/work/history', '/work/biters']
    },
    {
      id: 'messages',
      label: 'メッセージ',
      path: user ? '/chat' : '/register/type',
      icon: ChatBubbleLeftRightIcon,
      activeIcon: ChatBubbleLeftRightIconSolid,
      activePaths: ['/chat']
    },
    {
      id: 'mypage',
      label: 'マイページ',
      path: user ? '/mypage' : '/register/type',
      icon: UserIcon,
      activeIcon: UserIconSolid,
      activePaths: ['/mypage', '/profile', '/wallet-management', '/identity-verification']
    }
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50">
      <div className="flex items-center justify-around h-16 max-w-md mx-auto">
        {navItems.map((item) => {
          const active = isActive(item);
          const Icon = active ? item.activeIcon : item.icon;

          return (
            <Link
              key={item.id}
              to={item.path}
              className={`flex flex-col items-center justify-center flex-1 h-full px-2 transition-colors ${active
                ? 'text-blue-600'
                : 'text-gray-500 hover:text-gray-700'
                }`}
            >
              <Icon className="w-6 h-6 mb-1" />
              <span className="text-xs font-medium leading-none">
                {item.label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNavigation;